import React from 'react'
import About from './About'

const Brand = () => {
  return (
    <div><About/></div>
  )
}

export default Brand